import * as yup from "yup";

export const defaultFormValues = {
  id: undefined,
  name: "",
  defaultTemplateType: "thermal",
  enabled: true,
  existingLogoURL: "",
  settings: {
    header: "",
    footer: "",
    displayCustomerDetails: true,
    labelTax: "GST Total",
  },
};

export const schema = yup.object().shape({
  id: yup.string().optional(),
  name: yup.string().required("Name is required"),
  defaultTemplateType: yup.string().optional(),
  enabled: yup.boolean().required("Enabled is required"),
  existingLogoURL: yup.string().optional(),
  settings: yup.object().shape({
    header: yup.string().optional(),
    footer: yup.string().optional(),
    displayCustomerDetails: yup
      .boolean()
      .required("Display Customer Details is required"),
    labelTax: yup.string().optional(),
  }),
});
